import { SHERBERT_ASSETS_API_URL_V2 } from "../urls.js";
import { sherbertFetch } from "./networkUtils/sherbertFetch.js";
/**
 * Delete an asset. If you want to only hide the asset, use the hideAsset function instead.
 * @param options - The options for deleting an asset
 * @param options.assetId - The ID of the asset to delete
 * @param options.authorizationHeader - Function that returns the authorization header to use for the request
 * @param options.ifMatchHeader - [optional] The If-Match header to use for the request (defaults to "*")
 * @example
 * ```ts
 * deleteAsset({
 *   assetId: "123",
 *   authorizationHeader: () => `Bearer ${token}`,
 * });
 * ```
 */
export async function deleteAsset({ assetId, authorizationHeader, ifMatchHeader = "*", }) {
    await sherbertFetch(() => [
        `${SHERBERT_ASSETS_API_URL_V2}/${assetId}`,
        {
            method: "DELETE",
            headers: {
                Authorization: authorizationHeader(),
                "If-Match": ifMatchHeader,
            },
        },
    ]);
}
